import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourOptionsApi from '@/features/dashboard/tourOptions/api/tourOptionsApi.ts';
import { toast } from 'sonner';
import { tourOptionsApiQueryKeys } from '@/features/dashboard/tourOptions/api/tourOptionsApi.queryKeys.ts';
import { notifyTourOptionLimitWarnings } from '@/features/dashboard/tourOptions/hooks/tourOptionLimitWarnings.ts';
import { invalidateTourStatsQueries } from '@/utils/invalidateTourStatsQueries.ts';

export default function useCreateTourOption() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tourOptionsApi.create,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: tourOptionsApiQueryKeys.byTourId(data.tourId),
      });
      invalidateTourStatsQueries(queryClient, data.tourId);
      toast.success('Opcja wyjazdu została zapisana');
      void notifyTourOptionLimitWarnings(data.tourId, data);
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania danych.',
      });
    },
  });
}
